"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmedIcon = void 0;
var jsx_runtime_1 = require("preact/jsx-runtime");
var SimpleDate_1 = require("../../Date/SimpleDate");
var ConfirmedIconBase_1 = require("../icons/ConfirmedIconBase");
var ConfirmedIcon = function (_a) {
    var config = _a.config, shipment = _a.shipment;
    return ((0, jsx_runtime_1.jsxs)("div", { class: "artajs__tracking__timeline__default__step__icon", children: [(0, jsx_runtime_1.jsx)(ConfirmedIconBase_1.ConfirmedIconBase, { config: config }), (0, jsx_runtime_1.jsxs)("div", { class: "artajs__tracking__timeline__status__text__wrapper", children: [(0, jsx_runtime_1.jsx)("div", { class: "artajs__tracking__timeline__status__text__large", children: config.text.confirmedLabel }), (0, jsx_runtime_1.jsx)(SimpleDate_1.SimpleDate, { date: shipment.confirmed_at, dateConfig: config.text.dates })] })] }));
};
exports.ConfirmedIcon = ConfirmedIcon;
